import { render, staticRenderFns } from "./DetailType4.vue?vue&type=template&id=cca1df24&"
import script from "./DetailType4.vue?vue&type=script&lang=js&"
export * from "./DetailType4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports